'use strict';

require('./partials/accordionToggler.js');
require('./partials/accordionPanel.js');
require('./partials/accordionItem.js');
const { getDependencyClass } = require('../../lib/dependencies.js');
const performanceMeasure = require('../../lib/performanceMeasure.js');
let measure = performanceMeasure('webcomponents:accordion');

getDependencyClass('phoenix-page').then((pageClass) => {
    /**
     * @class
     * PhoenixAccordion
     *
     * @classdesc
     * PhoenixAccordion is a Web Component to create accordion UI, to reveal
     * and hide content based on a toggler. The general usage of this is
     * for accordions, where an accordion may have several panels of which only
     * one may be visible at a time.
     *
     * Pug Mixin (for accordions): server/web/partials/accordion.pug
     *
     * @example
     *  <phoenix-accordion class="m-accordion" id="foo-accordion">
     *      <ul>
     *          <li>
     *              <phoenix-accordion-item
     *                  class="m-accordion--item"
     *                  accordion-id="foo-accordion"
     *                  id="foo"
     *              >
     *                  <phoenix-accordion-toggler
     *                      accordion-id="foo-accordion"
     *                      item-id="foo"
     *                  >
     *                      <button
     *                          aria-expanded="false"
     *                          id="toggle-foo-accordion"
     *                          aria-controls="panel-foo">Toggler</button>
     *                  </phoenix-accordion-toggler>
     *                  <phoenix-accordion-panel
     *                      hidden
     *                      accordion-id="foo-accordion"
     *                      id="foo-panel"
     *                      aria-labelledby="toggle-foo"
     *                   >
     *                      Accordion Content
     *                   </phoenix-accordion-panel>
     *              </phoenix-accordion-item>
     *          </li>
     *      </ul>
     *  </phoenix-accordion>
     */
    class PhoenixAccordion extends pageClass.PhoenixElement {
        get observedEmittedEvents() {
            return ['phoenix:accordion'];
        }

        connectedCallback() {
            super.connectedCallback();
        }

        emittedEventCallback(name, args = {}) {
            const itemId = args.detail && args.detail.itemId;
            const accordionId = args.detail && args.detail.accordionId;

            if (accordionId !== this.id) {
                return;
            }

            if (name === 'phoenix:accordion') {
                this.notify(itemId, accordionId);
            }
        }

        notify(itemId, accordionId) {
            const eventName = 'phoenix:accordion:active';
            this.emitEvent(eventName, {
                bubbles: true,
                detail: {
                    key: eventName,
                    itemId: itemId,
                    accordionId: accordionId,
                },
            });
        }
    }

    window.customElements.define('phoenix-accordion', PhoenixAccordion);
    measure.end();
});
